
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/addresses/[state_slug]/[city_slug]",
      function () {
        return require("private-next-pages/addresses/[state_slug]/[city_slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/addresses/[state_slug]/[city_slug]"])
      });
    }
  